import { useTranslation } from "react-i18next";
import { TooltipBookingsTimesSeriesProps } from "../types";
import { formatMonthLabel } from "../utils";

export function TooltipBookingsTimesSeries({
  active,
  data,
  ...props
}: TooltipBookingsTimesSeriesProps) {
  const [translate] = useTranslation(["dashboard"]);

  const currentData = data.find((p: any) => p.label === props.label);

  if (!active || !currentData) {
    return null;
  }

  return (
    <div className="bg-white border border-ligtgray-400 rounded-2xl min-w-[180px]">
      <div className="font-normal text-darkgray-900 mb-3 pb-2 bg-lightgray-400 rounded-t-2xl p-4 text-center capitalize">
        {formatMonthLabel(currentData.label, true, translate)}
      </div>
      <div className="space-y-2 pt-0 p-4">
        <div className="flex items-center gap-2">
          <div className={`w-3 h-3 rounded-full bg-black`} />
          <span className="text-sm text-darkgray-800 font-normal">
            {translate("dashboard-bookings-timeseries-title")}:{" "}
            {currentData.value}
          </span>
        </div>
      </div>
    </div>
  );
}
